import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSnackbar } from "notistack";
import "react-datepicker/dist/react-datepicker.css";
import AdminLoader from "../../components/common/loader/AdminLoader";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch, useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { fetchEmployees } from "../../store/slices/employeeAdminSlice";
import { fetchFilesByLeadId } from "../../store/slices/fileSlice";
import { fetchServiceTypes } from "../../store/slices/serviceTypesSlice";
import { fetchLeadTypes } from "../../store/slices/leadTypeSlice";
import { fetchSources } from "../../store/slices/sourceSlice";
import { fetchStatus } from "../../store/slices/statusSlice";
import { fetchGroups } from "../../store/slices/groupSlice";
import { fetchLeads, updateLead } from "../../store/slices/leadsSlice";
import {
  resetcurrentLeadID,
  setcurrentLeadID,
  setCurrentPageTitle,
} from "../../store/slices/pageSlice";
import FileUploadEditLead from "./FileUploadEditLead";
import {
  getAllFiles,
  getFilesByLead,
  uploadFile,
} from "../../store/slices/FileDataSlice";
// import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import { fetchCompanyProfiles } from "../../store/slices/companyProfileSlice";
import { resolveCountryInputConfig, useCurrencySymbol } from "../../utils/currencyUtils";
import { useLoggedUser } from "../../utils/useLoggedUser";
import DateConversion from "../../utils/DateConversion";
import CommaConvert from "../../utils/CommaConvert";
import {
  deleteLeadId,
  generateLeadId,
} from "../../store/slices/lead/leadIdGenerationSlice";
import { fetchAllProjects } from "../../store/slices/projectsSlice";
import { fetchSalesHourlyRates } from "../../store/slices/salesHourlyRateSlice";
import { updateProjectQuotedStatusThunk } from "../../store/slices/projectQuoteSlice";
import { buildProjectsDetailsPayloadForLeadEdit } from "../../utils/buildProjectsDetailsForUpdateLockQuoted";
import { getFeatureAccessLevel } from "../../utils/featureAccessUtils";
import { fetchOtherExpenses } from "../../store/slices/otherexpenses";
import {
  getLoggedSalesUserId,
  getPerdiemAndAverageCostFromExpenses,
  scopeOtherExpensesForUser,
} from "../../utils/salespersonRatesScope";

const EditLead = () => {
  const dispatch = useDispatch();
  const currency = useCurrencySymbol();
  const { getDatePlaceholder, getDateFormat } = DateConversion();
  const USAComma = CommaConvert();
  const [quotationId, setquotationId] = useState("");
  const navigate = useNavigate();
  const { projects } = useSelector((state) => state.projects);
  const { data: salesHourlyRateData } = useSelector((state) => state.salesHourlyRate);
  const { items: otherExpenses } = useSelector((state) => state.otherExpenses);
  const loggedInUserId = useSelector((state) => state.leads.loggedInUserId);

  console.log("Projects in Edit Lead:", projects);
  // const location = useLocation();

  useEffect(() => {
    dispatch(setCurrentPageTitle("Edit Lead"));
    dispatch(fetchAllProjects());
    dispatch(fetchOtherExpenses());
  }, [dispatch]);

  useEffect(() => {
    dispatch(setcurrentLeadID(quotationId));
  }, [dispatch, quotationId]);

  const [ProjectName, setProjectName] = useState("");

  const [allowtoedit, setAllowtoedit] = useState([]);
  useEffect(() => {
    if (!quotationId || !projects?.length) {
      setAllowtoedit([]);
      return;
    }
    const matchedProject = projects.filter(
      (proj) => proj.quotationId === quotationId
    );
    setAllowtoedit(matchedProject || []);
  }, [projects, quotationId]);


  const [LeadReports, setLeadReports] = useState([]);
  const [GroupNames, setGroupNames] = useState([]);
  const [LeadTypes, setLeadTypes] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [Sources, setSources] = useState([]);
  const [serviceTypes, setServiceTypes] = useState([]);
  const [AssignedGroup, setAssignedGroup] = useState("");
  const [selectedGroupId, setSelectedGroupId] = useState("");
  const { leads } = useSelector((state) => state.leads);
  const { group } = useSelector((state) => state.group);
  const { status } = useSelector((state) => state.status);
  const { source } = useSelector((state) => state.source);
  const { leadTypesRedux } = useSelector((state) => state.leadTypesRedux);
  const { serviceTypesRedux } = useSelector((state) => state.serviceTypesRedux);
  const { profiles } = useSelector((state) => state.companyProfile);
  const [, setPackageData] = useState("");
  const [LeadOwner, SetLeadOwner] = useState("");
  const [ClientName, setClientName] = useState("");
  const [LeadType, setLeadType] = useState("");
  const [QuotedValue, setQuotedValue] = useState("");
  const [ClientPhone, setClientPhone] = useState("");
  const [ClientContactName, setClientContactName] = useState("");
  const [Status, setStatus] = useState("");
  const [Source, setSource] = useState("");
  const quotationIdRef = useRef(quotationId);
  const firstLettersRef = useRef({ group: "", clientName: "", projectName: "" });
  const [, setShowProb] = useState(false);
  const [Probability, setProbability] = useState("");
  const [, setshowRef] = useState(false);
  const [Reference, setReference] = useState("");
  const [ClientEmail, setClientEmail] = useState("");
  const [comments, setComments] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const [, setTodaysDate] = useState("");
  const [editingLeadReport, setEditingLeadReport] = useState(null);
  const [isLoading, SetisLoading] = useState(false);
  const [showSourceDropdown, setShowSourceDropdown] = useState("");
  const [showGroupDropdown, setShowGroupDropdown] = useState("");
  const [showServiceDropdown, setShowServiceDropdown] = useState("");
  const [showLeadTypeDropdown, setShowLeadTypeDropdown] = useState("");
  const [showStatusDropdown, setShowStatusDropdown] = useState("");
  const [showProbabilityDropdown, setShowProbabilityDropdown] = useState("");
  const [Category] = useState("");
  const [SelectedCategory, setSelectedCategory] = useState("");
  const [fileNames, setFileNames] = useState([]);
  // const [, setShowQuoteModal] = useState(false);
  // const [, setselectedProject] = useState("");
  // const [, setselectedGroup] = useState("");
  const employeeslist = useSelector((state) => state.employees.employees);

  const email = localStorage.getItem("email");
  const currentEmployee = employeeslist?.find((emp) => emp.EmpEmail === email) ?? null;
  const hasNoFeatureConfig = !currentEmployee || !Array.isArray(currentEmployee?.featureAccess) || currentEmployee.featureAccess.length === 0;
  const editLeadAccessLevel = getFeatureAccessLevel(currentEmployee, "EDIT LEAD");
  const isViewOnly = !!currentEmployee && !hasNoFeatureConfig && editLeadAccessLevel && String(editLeadAccessLevel).trim().toUpperCase() === "VIEW ONLY";

  const [TypeService, setSelectedServices] = useState([]);
  const [LeadDate, setLeadDate] = useState("");
  const [FollowupDate, setFollowupDate] = useState("");

  useEffect(() => {
    dispatch(fetchLeads());
    dispatch(fetchGroups());
    dispatch(fetchStatus());
    dispatch(fetchSources());
    dispatch(fetchLeadTypes());
    dispatch(fetchServiceTypes());
    dispatch(getAllFiles());
    dispatch(fetchCompanyProfiles());
    dispatch(fetchEmployees());
    dispatch(fetchSalesHourlyRates());
  }, [dispatch]);

  useEffect(() => {
    setLeadReports(leads);
    setGroupNames(group);
    setLeadTypes(leadTypesRedux);
    setStatuses(status);
    setSources(source);
    // setServiceTypes(serviceTypesRedux);
  }, [leads, group, leadTypesRedux, status, source, serviceTypesRedux]);

  const getGroupId = useCallback((groupObj) => {
    return String(groupObj?._id || groupObj?.id || "");
  }, []);

  const getGroupName = useCallback((groupObj) => {
    return (
      groupObj?.newGroupName ||
      groupObj?.groupname ||
      groupObj?.groupName ||
      groupObj?.name ||
      ""
    );
  }, []);

  const groupNameById = useMemo(() => {
    const map = new Map();
    (group || []).forEach((g) => {
      const id = getGroupId(g);
      const name = getGroupName(g);
      if (id && name) map.set(id, name);
    });
    return map;
  }, [group, getGroupId, getGroupName]);

  const selectedGroupName = useMemo(() => {
    if (selectedGroupId && groupNameById.has(String(selectedGroupId))) {
      return groupNameById.get(String(selectedGroupId));
    }
    return AssignedGroup || "";
  }, [AssignedGroup, selectedGroupId, groupNameById]);

  useEffect(() => {
    if (profiles && profiles.length > 0) {
      const packages = profiles[0].subscriptionpackage;
      if (packages) {
        setPackageData(packages);
      }
    }
  }, [profiles]);
  useEffect(() => {
    if (!Array.isArray(group) || (!selectedGroupId && !AssignedGroup)) return;
    const matchedGroup = selectedGroupId
      ? group.find((g) => getGroupId(g) === String(selectedGroupId))
      : group.find((g) => getGroupName(g) === AssignedGroup);

    if (matchedGroup) {
      setServiceTypes(matchedGroup.servicetype || []);
    } else {
      setServiceTypes([]); // Reset if no match
    }
  }, [AssignedGroup, group, selectedGroupId, getGroupId, getGroupName]);







  console.log("SFsfsfsd", LeadDate)
  const parseTypedDate = (value, format) => {
    if (!value) return null;
    let day, month, year;
    if (format === "MM-dd-yyyy") {
      [month, day, year] = value.split("-");
    } else if (format === "dd-MM-yyyy") {
      [day, month, year] = value.split("-");
    } else {
      return null;
    }
    const parsed = new Date(year, month - 1, day);
    return isNaN(parsed) ? null : parsed;
  };


  useEffect(() => {
    quotationIdRef.current = quotationId;
  }, [quotationId]);

  const handleSendLeadID = useCallback(async (forceRegenerate = false) => {
    // Extract first letters only
    const firstLetterGroup = selectedGroupName ? selectedGroupName.trim().charAt(0).toUpperCase() : "";
    const firstLetterClient = ClientName ? ClientName.trim().charAt(0).toUpperCase() : "";
    const firstLetterProject = ProjectName ? ProjectName.trim().charAt(0).toUpperCase() : "";

    // Only proceed if all three fields have at least one character
    if (!firstLetterGroup || !firstLetterClient || !firstLetterProject) return;

    const currentQuotationId = quotationIdRef.current;
    const currentFirstLetters = firstLettersRef.current;

    // Check if first letters have changed
    const firstLettersChanged =
      currentFirstLetters.group !== firstLetterGroup ||
      currentFirstLetters.clientName !== firstLetterClient ||
      currentFirstLetters.projectName !== firstLetterProject;

    // If first letters haven't changed and we already have an ID, don't call API
    if (!forceRegenerate && !firstLettersChanged && currentQuotationId && currentQuotationId.length > 5) {
      return;
    }

    try {
      // Delete old ID if it exists and first letters changed
      if (firstLettersChanged && currentQuotationId && currentQuotationId.length > 5) {
        try {
          await dispatch(
            deleteLeadId({
              generatedLeadId: currentQuotationId,
            })
          ).unwrap();
        } catch (error) {
          console.error("Delete Lead ID failed", error);
        }
        setquotationId("");
        quotationIdRef.current = "";
      }

      // Update the first letters ref
      firstLettersRef.current = {
        group: firstLetterGroup,
        clientName: firstLetterClient,
        projectName: firstLetterProject,
      };

      // Call API with only first letters
      const response = await dispatch(
        generateLeadId({
          group: firstLetterGroup,
          clientName: firstLetterClient,
          projectName: firstLetterProject,
        })
      ).unwrap();
      setquotationId(response.quotationId);
      quotationIdRef.current = response.quotationId;
    } catch (error) {
      console.error("Generate Lead ID failed", error);
    }
  }, [selectedGroupName, ClientName, ProjectName, dispatch]);

  // Call handleSendLeadID when first letters of AssignedGroup, ClientName, or ProjectName change
  useEffect(() => {
    // Extract first letters only
    const firstLetterGroup = selectedGroupName ? selectedGroupName.trim().charAt(0).toUpperCase() : "";
    const firstLetterClient = ClientName ? ClientName.trim().charAt(0).toUpperCase() : "";
    const firstLetterProject = ProjectName ? ProjectName.trim().charAt(0).toUpperCase() : "";

    // Only proceed if all three fields have at least one character
    if (!firstLetterGroup || !firstLetterClient || !firstLetterProject) return;

    const currentFirstLetters = firstLettersRef.current;

    // Check if first letters have changed
    const firstLettersChanged =
      currentFirstLetters.group !== firstLetterGroup ||
      currentFirstLetters.clientName !== firstLetterClient ||
      currentFirstLetters.projectName !== firstLetterProject;

    // Only call API if first letters have changed
    if (firstLettersChanged) {
      handleSendLeadID(true);
    }
  }, [selectedGroupName, ClientName, ProjectName, handleSendLeadID]);


  console.log("Gdhfj", editingLeadReport);
  useEffect(() => {
    dispatch(fetchEmployees());
  }, [dispatch]);

  const { id } = useParams();
  const dropdownRefSource = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRefSource.current &&
        !dropdownRefSource.current.contains(event.target)
      ) {
        setShowSourceDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const dropdownRefGroup = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRefGroup.current &&
        !dropdownRefGroup.current.contains(event.target)
      ) {
        setShowGroupDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const dropdownRefService = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRefService.current &&
        !dropdownRefService.current.contains(event.target)
      ) {
        setShowServiceDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const dropdownRefLeadType = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRefLeadType.current &&
        !dropdownRefLeadType.current.contains(event.target)
      ) {
        setShowLeadTypeDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const dropdownRefStatus = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRefStatus.current &&
        !dropdownRefStatus.current.contains(event.target)
      ) {
        setShowStatusDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const dropdownRefProbability = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRefProbability.current &&
        !dropdownRefProbability.current.contains(event.target)
      ) {
        setShowProbabilityDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (LeadReports.length > 0) {
      const ReportToEdit = LeadReports.find(
        (LeadReport) => String(LeadReport.id) === String(id)
      );
      setEditingLeadReport(ReportToEdit || null);
    }
  }, [LeadReports, id]);

  const handleSourceChange = (source) => {
    const value = source;
    setSource(value);
    setShowSourceDropdown(false);
  };

  const handleGroupChange = (groupObj) => {
    const value = getGroupName(groupObj);
    const id = getGroupId(groupObj);
    setAssignedGroup(value);
    setSelectedGroupId(id);

    // Clear the error when a valid group is selected

    setShowGroupDropdown(false);
  };
  const handleServiceChange = (service) => {
    setSelectedServices((prevSelected) => {
      if (prevSelected.includes(service)) {
        // Unselect if already selected
        return prevSelected.filter((s) => s !== service);
      } else {
        // Select if not selected
        return [...prevSelected, service];
      }
    });
  };
  const handleLeadTypeChange = (Leadtype) => {
    const value = Leadtype;
    setLeadType(value);
    setShowLeadTypeDropdown(false);
  };
  const handleStatusChange = (status) => {
    const value = status;
    setStatus(value);
    setShowStatusDropdown(false);
    if (value !== "Pending") {
      setProbability("");
    }
  };
  const handleProbabilityChange = (Probability) => {
    const value = Probability;
    setProbability(value);

    setShowProbabilityDropdown(false);
  };

  useEffect(() => { }, [LeadReports]);

  const Cancel = () => {
    // e.preventDefault();
    setClientName("");
    setLeadDate("");
    setClientPhone("");
    setClientContactName("");
    setStatus("");
    setProjectName("");
    setQuotedValue("");
    setSelectedServices("");
    setLeadType("");
    setAssignedGroup("");
    setSelectedGroupId("");
    setSource("");
    setFollowupDate("");
    setComments("");
    navigate(-1);
    dispatch(setcurrentLeadID());
  };

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setTodaysDate(today);
  }, []);

  useEffect(() => {
    if (editingLeadReport) {
      console.log("editingLeadReport", editingLeadReport);

      SetLeadOwner(editingLeadReport.LeadOwner);
      setClientName(editingLeadReport.ClientName);
      setLeadDate(editingLeadReport.LeadDate);
      setSource(editingLeadReport.Source);
      setClientContactName(editingLeadReport.ClientContactName);
      setClientPhone(editingLeadReport.ClientPhone);
      setProjectName(editingLeadReport.ProjectName);
      setSelectedServices(editingLeadReport.TypeService);
      setQuotedValue(editingLeadReport.QuotedValue);
      const reportGroupId = String(
        editingLeadReport?.groupid?._id ||
        editingLeadReport?.groupid?.id ||
        editingLeadReport?.groupid ||
        ""
      );
      const reportGroupNameFromSlice = reportGroupId
        ? groupNameById.get(reportGroupId)
        : "";
      const reportGroupName = reportGroupNameFromSlice || editingLeadReport.AssignedGroup || "";
      setSelectedGroupId(reportGroupId);
      setAssignedGroup(reportGroupName);
      setLeadType(editingLeadReport.LeadType);
      setStatus(editingLeadReport.Status);
      setFollowupDate(editingLeadReport.FollowupDate);
      setClientEmail(editingLeadReport.ClientEmail);
      setReference(editingLeadReport.Reference);
      setComments(editingLeadReport.comments);
      setProbability(editingLeadReport.Probability);
      setquotationId(editingLeadReport.quotationId);
      // SetAssignedPeople(editingLeadReport.AssignedPeople)
      setSelectedCategory(editingLeadReport.Category);

      // Initialize first letters ref to prevent unnecessary API calls on load
      if (reportGroupName && editingLeadReport.ClientName && editingLeadReport.ProjectName) {
        firstLettersRef.current = {
          group: reportGroupName.trim().charAt(0).toUpperCase(),
          clientName: editingLeadReport.ClientName.trim().charAt(0).toUpperCase(),
          projectName: editingLeadReport.ProjectName.trim().charAt(0).toUpperCase(),
        };
      }
    }
  }, [editingLeadReport, groupNameById]);

  useEffect(() => {
    if (Source === "Reference") {
      setshowRef(true);
    }

    if (Status === "Pending") {
      setShowProb(true);
    }
  }, [Source, Status]);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const Submit = async (e) => {
    e.preventDefault();
    if (isViewOnly) return;

    if (
      !ClientName ||
      !LeadType ||
      (Status !== "Won" && Status !== "Lost" && !FollowupDate) ||
      (Status === "Pending" &&
        !["High", "Medium", "Low"].includes(Probability)) ||
      !LeadDate ||
      !Source ||
      !ClientPhone ||
      !ClientContactName ||
      !TypeService ||
      !Status ||
      !ProjectName ||
      !QuotedValue ||
      !TypeService.length
      // !AssignedPeopleEmail.length > 0 ||
      // !AssignedPeople.length === 0
    ) {
      enqueueSnackbar("Please fill all the fields!", { variant: "error" });
      return;
    }

    if (!emailRegex.test(ClientEmail)) {
      enqueueSnackbar("Please enter a valid email address!", {
        variant: "error",
      });
      return;
    }

    if (Status === "Pending" && !Probability) {
      enqueueSnackbar("Please provide Probability for Pending status!", {
        variant: "error",
      });
      return;
    }

    if (Source === "Reference" && !Reference) {
      enqueueSnackbar("Please enter Reference!", { variant: "error" });
      return;
    }

    SetisLoading(true);

    try {
      const fallbackGroupObj = Array.isArray(group)
        ? group.find((g) => getGroupName(g) === AssignedGroup)
        : null;
      const groupid = selectedGroupId || getGroupId(fallbackGroupObj);

      const updatedLeadData = {
        LeadOwner,
        ClientName,
        ProjectName,
        LeadDate,
        QuotedValue,
        Status,
        AssignedGroup: selectedGroupName,
        groupid,
        LeadType,
        FollowupDate,
        Probability: Status === "Pending" ? Probability : "",
        Source,
        Reference,
        TypeService,
        ClientContactName,
        ClientEmail,
        ClientPhone,
        comments,
        // AssignedPeople,
        Category,
        quotationId,
        // AssignedPeopleEmail,
      };
      await dispatch(
        updateLead({ id: editingLeadReport.id, updatedData: updatedLeadData })
      ).unwrap();

      const isErpPackage = profiles?.[0]?.subscriptionpackage === "ERP";
      const prevStatusNorm = String(editingLeadReport?.Status ?? "").trim().toLowerCase();
      const nextStatusTrimmed = String(Status ?? "").trim();
      const shouldLockQuoted =
        isErpPackage &&
        prevStatusNorm === "pending" &&
        (nextStatusTrimmed === "Won" || nextStatusTrimmed === "Won Recurring") &&
        quotationId;

      if (shouldLockQuoted) {
        let expensesList = otherExpenses;
        if (!expensesList?.length) {
          try {
            expensesList = await dispatch(fetchOtherExpenses()).unwrap();
          } catch {
            expensesList = [];
          }
        }
        const loggedUserId = getLoggedSalesUserId(
          loggedInUserId,
          employeeslist,
          email
        );
        const expensesForUser = scopeOtherExpensesForUser(expensesList, {
          loggedUserId,
        });
        const { perdiem, averagecost } =
          getPerdiemAndAverageCostFromExpenses(expensesForUser);
        let ratesList = salesHourlyRateData;
        if (!ratesList?.length) {
          try {
            ratesList = await dispatch(fetchSalesHourlyRates()).unwrap();
          } catch {
            ratesList = [];
          }
        }
        const projectsDetails = buildProjectsDetailsPayloadForLeadEdit(
          projects,
          ratesList,
          quotationId,
          ProjectName,
          { perdiem, avgcost: averagecost },
          loggedUserId
        );
        if (projectsDetails.length > 0) {
          try {
            await dispatch(updateProjectQuotedStatusThunk(projectsDetails)).unwrap();
            await dispatch(fetchAllProjects());
          } catch (lockErr) {
            console.error("Failed to update project quoted status:", lockErr);
          }
        }
      }

      await handleFileUpload(editingLeadReport._id);
      enqueueSnackbar("Lead Updated Successfully!", { variant: "success" });
      // navigate(`/dashboard/leadreport`);
      navigate(-1);
      dispatch(fetchLeads());
      // Reset form fields
      setClientName("");
      setLeadDate("");
      setClientPhone("");
      setClientContactName("");
      setStatus("");
      setProjectName("");
      setQuotedValue("");
      setSelectedServices("");
      setAssignedGroup("");
      setSelectedGroupId("");
      setLeadType("");
      setFollowupDate("");
      setProbability("");
      setClientEmail("");
      setSource("");
      setReference("");
      setComments("");
      // SetAssignedPeople([])
      setSelectedCategory("");
      // setAssignedPeopleEmail([])
    } catch (error) {
      console.error("Error:", error);
      const errorMessage =
        error?.error ||
        error?.response?.data?.error ||
        error?.message ||
        "Something went wrong!";
      enqueueSnackbar(errorMessage, { variant: "error" });
    } finally {
      SetisLoading(false);
      dispatch(setcurrentLeadID());
    }
  };

  // function formatNumberWithCommas(number) {
  //   if (number === "" || number === null || number === undefined) return "";
  //   const parts = number.toString().split(".");
  //   parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  //   return parts.join(".");
  // }

  // const { setFileUpload } = useLead();
  const [, setFileUpload] = useState(0);

  // const [showuploadedfiles] = useState([]);
  const [, setFetchedFiles] = useState([]);

  const fetchFiles = async (leadId) => {
    try {
      const response = await dispatch(fetchFilesByLeadId(leadId)).unwrap(); // Dispatch Redux action
      setFetchedFiles(response);
    } catch (error) {
      console.error("Error fetching files:", error);
    }
  };

  const [editfetchedfiles, seteditFetchedFiles] = useState([]);

  useEffect(() => {
    if (!editingLeadReport) return; // guard: nothing to fetch yet

    const loadFiles = async () => {
      try {
        const files = await dispatch(getFilesByLead(editingLeadReport._id));
        seteditFetchedFiles(files);
      } catch (err) {
        console.error("Error fetching files:", err);
      }
    };

    loadFiles();
  }, [editingLeadReport, dispatch]);

  const handleFileUpload = async (leadID) => {
    if (!fileNames.length) {
      return;
    }
    const uploadDate = new Date().toISOString().slice(0, 10); // "2024-07-11"
    const formData = new FormData();

    formData.append("leadId", leadID);
    formData.append("uploadDate", uploadDate);

    fileNames.forEach((file) => {
      formData.append("selectedCategory", file.selectedCategory);
      formData.append("files", file);
    });

    try {
      await dispatch(uploadFile(formData)).unwrap();
      setFileUpload((prev) => prev + 1);
      dispatch(fetchFilesByLeadId(id)); // Fetch updated files after upload
      fetchFiles();
    } catch (error) {
      enqueueSnackbar("Error Occurred While uploading file", {
        variant: "error",
      });
      console.error(
        "Error uploading file:",
        error.response?.data?.error || error.message
      );
    }
  };

  useEffect(() => {
    if (FollowupDate && LeadDate) {
      const lead = new Date(LeadDate);
      const followup = new Date(FollowupDate);

      if (followup < lead) {
        enqueueSnackbar("Followup date must be after lead date.", {
          variant: "error",
        });
        setFollowupDate(null);
      }
    }
  }, [FollowupDate, LeadDate, enqueueSnackbar]);

  // const auth = localStorage.getItem("auth");

  const loggedEmployee = useLoggedUser();

  const { iso2: defaultCountry, onlyCountries: allowedCountries } =
    resolveCountryInputConfig({
      countrycode: loggedEmployee?.countrycode,
      region: loggedEmployee?.region,
    });

  const formatPhoneNumberForDisplay = (phoneNumber) => {
    if (!phoneNumber) return "";

    const phoneStr = String(phoneNumber);
    if (phoneStr.startsWith("+")) {
      return phoneStr;
    }

    const countryCode = loggedEmployee?.countrycode || "";

    if (countryCode && !phoneStr.startsWith(countryCode.replace("+", ""))) {
      return countryCode + phoneStr;
    }

    return phoneStr;
  };

  return (
    <div className=" bg-[#f3f8f8] h-full">
      {isLoading ? (
        <AdminLoader isLoading={isLoading} />
      ) : (
        <>
          <div className="relative justify-center">
            <br />

            <div className="pt-1 bg-white rounded-md">

              <div className="rounded-md p-2 pb-10">
                <div
                  className="grid grid-cols-1 md:grid-cols-4 gap-4 "
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  {/* Lead Date */}
                  <div
                    className="pt-1  mb-4"
                    style={{ width: "22%", height: "4%" }}
                  >
                    <label className="block" htmlFor="date">
                      Lead Date
                      <span className="text-red-700 text-xl">*</span>
                    </label>

                    <DatePicker
                      wrapperClassName="w-full"
                      selected={LeadDate}
                      dateFormat={getDateFormat()}
                      placeholderText={getDatePlaceholder()}
                      maxDate={new Date()}
                      showPopperArrow={false}
                      disabled={isViewOnly}
                      onChange={(date) => {
                        if (!(date instanceof Date) || isNaN(date)) return;
                        setLeadDate(date);
                      }}
                      onBlur={(e) => {
                        const parsed = parseTypedDate(
                          e.target.value,
                          getDateFormat
                        );
                        if (!parsed) return;
                        setLeadDate(parsed);
                      }}
                      className={`border w-full border-gray-400 rounded-md p-2 shadow-md outline-none ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                    />

                    {/* <DatePicker
                      wrapperClassName="w-full"
                      selected={LeadDate}
                      dateFormat={getDateFormat()}
                      placeholderText={getDatePlaceholder()}
                      maxDate={new Date()}
                      showPopperArrow={false}
                      onChange={(date) => {
                        if (!(date instanceof Date) || isNaN(date)) return;
                        if (date > new Date()) {
                          enqueueSnackbar("Future dates are not allowed", {
                            variant: "error",
                          });
                          return;
                        }
                        setLeadDate(date);
                      }}
                      onBlur={(e) => {
                        const parsed = parseTypedDate(
                          e.target.value,
                          getDateFormat
                        );
                        if (!parsed) return;

                        if (parsed > new Date()) {
                          enqueueSnackbar("Future dates are not allowed", {
                            variant: "error",
                          });
                          return;
                        }
                        setLeadDate(parsed);
                      }}
                      className="border w-full border-gray-400 rounded-md p-2 shadow-md outline-none"
                    /> */}
                  </div>

                  {/* Group */}
                  <div
                    className="pt-1  mb-4"
                    style={{ width: "22%", height: "4%" }}
                  >
                    <label className="block" htmlFor="Source">
                      Group<span className="text-red-700 text-xl">*</span>
                    </label>
                    <div className="w-full ">
                      <div
                        ref={dropdownRefGroup}
                        className="relative flex w-full  p-0 rounded-xl align-middle items-center"
                      >
                        <ExpandMoreIcon
                          color="white"
                          className={`absolute right-0 border-r border-gray-400 m-auto bg-white ${isViewOnly ? "cursor-not-allowed" : "cursor-pointer"}`}
                          onClick={() => {
                            if (isViewOnly) return;
                            setShowGroupDropdown(!showGroupDropdown);
                          }}
                        />

                        <button
                          type="button"
                          disabled={isViewOnly}
                          onClick={() => {
                            if (isViewOnly) return;
                            setShowGroupDropdown(!showGroupDropdown);
                          }}
                          className={`border w-full bg-white border-gray-400 text-nowrap rounded-md p-2 shadow-md text-start overflow-hidden outline-none ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                        >
                          {selectedGroupName ? selectedGroupName : <p>Select Group</p>}
                        </button>

                        {showGroupDropdown && (
                          <div
                            style={{ zIndex: 9999 }}
                            className="absolute top-full left-0 p-1 w-full cursor-pointer max-h-96 overflow-y-auto bg-white text-sm border border-gray-300 shadow-lg flex flex-col gap-1"
                          >
                            {GroupNames.map((groupItem) => (
                              <div
                                className="p-1 hover:bg-gray-200 cursor-pointer"
                                onClick={() => {
                                  handleGroupChange(groupItem);
                                  setSelectedServices([]); // Reset selected services when group changes
                                }}
                                key={getGroupId(groupItem)}
                                value={getGroupName(groupItem)}
                              >
                                {getGroupName(groupItem)}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Client Name */}
                  <div
                    className="pt-1  mb-4"
                    style={{ width: "22%", height: "4%" }}
                  >
                    <label className="block" htmlFor="Name">
                      Client Name<span className="text-red-700 text-xl">*</span>
                    </label>
                    <input
                      className={`border w-full border-gray-400 rounded-md p-2 overflow-hidden shadow-md outline-none ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                      type="text"
                      placeholder="Enter Client Name"
                      value={ClientName}
                      maxLength={30}
                      disabled={isViewOnly}
                      onChange={(e) => {
                        let value = e.target.value;
                        const filteredValue = value.replace(
                          /[^a-zA-Z0-9!@#$%*_\s-]/g,
                          ""
                        );
                        setClientName(filteredValue);
                      }}
                    />
                  </div>

                  {/* Project Name */}
                  <div
                    className="pt-1 mb-4"
                    style={{ width: "22%", height: "4%" }}
                  >
                    <label className="block" htmlFor="Name">
                      Project Name
                      <span className="text-red-700 text-xl">*</span>
                    </label>
                    <input
                      className={`border w-full border-gray-400 rounded-md p-2 overflow-hidden shadow-md outline-none ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                      type="text"
                      placeholder="Enter Project Name"
                      disabled={isViewOnly || allowtoedit?.length > 0}
                      maxLength={30}
                      value={ProjectName}
                      onChange={(e) => {
                        let value = e.target.value;
                        const filteredValue = value.replace(
                          /[^a-zA-Z0-9!@#$%*_\s-]/g,
                          ""
                        );
                        setProjectName(filteredValue);
                      }}
                    />
                  </div>
                </div>

                <div
                  className="grid grid-cols-1 md:grid-cols-4 gap-4"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  {/* Type of Service */}
                  <div
                    className="pt-1 mb-4"
                    style={{ width: "22%", height: "4%" }}
                  >
                    <label className="block" htmlFor="Source">
                      Type of Service
                      <span className="text-red-700 text-xl">*</span>
                    </label>
                    <div className=" bg-white">
                      <div
                        ref={dropdownRefService}
                        className="relative flex  p-0  rounded-xl align-middle items-center"
                      >
                        <ExpandMoreIcon
                          color="white"
                          className={`absolute right-2 m-auto bg-white ${isViewOnly ? "cursor-not-allowed" : "cursor-pointer"}`}
                          onClick={() => {
                            if (isViewOnly) return;
                            setShowServiceDropdown(!showServiceDropdown);
                          }}
                        />

                        <button
                          type="button"
                          disabled={isViewOnly}
                          onClick={() => {
                            if (isViewOnly) return;
                            setShowServiceDropdown(!showServiceDropdown);
                          }}
                          className={`border w-full bg-white border-gray-400 text-nowrap rounded-md p-2 shadow-md text-start overflow-hidden outline-none ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                        >
                          {serviceTypes.length === 0 ? (
                            <span className="text-black">No Service Type</span>
                          ) : TypeService.length > 0 ? (
                            <div className="flex overflow-hidden gap-1">
                              {TypeService.map((service) => (
                                <span
                                  key={service}
                                  className="bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-xs"
                                >
                                  {service}
                                </span>
                              ))}
                            </div>
                          ) : (
                            <span className="">Select Service Type</span>
                          )}
                        </button>

                        {showServiceDropdown && (
                          <div
                            style={{ zIndex: 9999 }}
                            className="absolute top-full left-0 p-1 w-full cursor-pointer max-h-96 overflow-y-auto bg-white text-sm border border-gray-300 shadow-lg flex flex-col gap-1"
                          >
                            {serviceTypes.map((serviceType) => {
                              const isSelected =
                                TypeService.includes(serviceType);
                              return (
                                <div
                                  key={serviceType}
                                  className={`p-1 cursor-pointer ${isSelected
                                    ? "bg-blue-100 font-semibold"
                                    : "hover:bg-gray-200"
                                    }`}
                                  onClick={() =>
                                    handleServiceChange(serviceType)
                                  }
                                >
                                  {serviceType}
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Quoted Value */}
                  <div
                    className="pt-1 mb-4"
                    style={{ width: "22%", height: "4%" }}
                  >
                    <label className="block" htmlFor="Name">
                      Quoted Value
                      <span className="text-red-700 text-xl">*</span> ({" "}
                      {currency} )
                    </label>
                    <input
                      className={`border w-full border-gray-400 rounded-md p-2 overflow-hidden shadow-md outline-none ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                      type="text"
                      placeholder="Enter Quoted Value"
                      inputMode="numeric"
                      maxLength={14}
                      pattern="[0-9]*"
                      disabled={isViewOnly}
                      value={USAComma(QuotedValue)}
                      onChange={(e) =>
                        setQuotedValue(
                          e.target.value.replace(/,/g, "").replace(/\D/g, "")
                        )
                      }
                    />
                  </div>

                  {/* Source */}
                  <div
                    className="pt-1  mb-4"
                    style={{ width: "22%", height: "4%" }}
                  >
                    <label className="block" htmlFor="Source">
                      Source<span className="text-red-700 text-xl">*</span>
                    </label>
                    <div className=" bg-white">
                      <div
                        ref={dropdownRefSource}
                        className="relative flex  p-0  rounded-xl align-middle items-center"
                      >
                        <ExpandMoreIcon
                          color="white"
                          className={`absolute right-2 m-auto ${isViewOnly ? "cursor-not-allowed" : "cursor-pointer"}`}
                          onClick={() => {
                            if (isViewOnly) return;
                            setShowSourceDropdown(!showSourceDropdown);
                          }}
                        />

                        <button
                          type="button"
                          disabled={isViewOnly}
                          onClick={() => {
                            if (isViewOnly) return;
                            setShowSourceDropdown(!showSourceDropdown);
                          }}
                          className={`border w-full bg-white border-gray-400 rounded-md p-2 shadow-md text-start overflow-hidden outline-none ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                        >
                          {Source ? Source : <p>Select Source</p>}
                        </button>

                        {showSourceDropdown && (
                          <div
                            style={{ zIndex: 9999 }}
                            className="absolute top-full left-0 w-full p-1 cursor-pointer max-h-96 overflow-y-auto bg-white text-sm border border-gray-300 shadow-lg flex flex-col gap-1"
                          >
                            {Sources.map((Sourc) => (
                              <div
                                className="p-1 hover:bg-gray-200 cursor-pointer"
                                onClick={() =>
                                  handleSourceChange(Sourc.newSource)
                                }
                                key={Sourc.id}
                                value={Sourc.newSource}
                              >
                                {Sourc.newSource}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Reference */}
                  <div
                    className="pt-1  mb-4"
                    style={{ width: "22%", height: "4%" }}
                  >
                    <label className="block" htmlFor="Name">
                      Reference
                      {Source === "Reference" ? (
                        <span className="text-red-700 text-xl">*</span>
                      ) : (
                        <span className="text-red-700 text-xl"></span>
                      )}
                    </label>
                    <input
                      className={`border w-full border-gray-400 rounded-md p-2 overflow-hidden shadow-md outline-none ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : Source !== "Reference" ? "bg-gray-200" : ""}`}
                      type="text"
                      maxLength={30}
                      placeholder="Enter Reference"
                      value={Source === "Reference" ? Reference : ""}
                      onChange={(e) => {
                        let value = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                        value = value.charAt(0).toUpperCase() + value.slice(1);
                        setReference(value);
                      }}
                      disabled={isViewOnly || Source !== "Reference"}
                    />
                  </div>
                </div>

                {/* Contact Person */}
                <div
                  className="grid grid-cols-1 md:grid-cols-4 gap-4"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <div className="mb-4" style={{ width: "22%", height: "4%" }}>
                    <label className="block" htmlFor="Name">
                      Contact Person
                      <span className="text-red-700 text-xl">*</span>
                    </label>
                    <input
                      className={`border w-full border-gray-400 rounded-md p-2 overflow-hidden shadow-md outline-none ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                      type="text"
                      placeholder="Enter Person Name"
                      maxLength={30}
                      disabled={isViewOnly}
                      value={ClientContactName}
                      onChange={(e) => {
                        let value = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                        value = value.charAt(0).toUpperCase() + value.slice(1);
                        setClientContactName(value);
                      }}
                    />
                  </div>

                  <div className="mb-4" style={{ width: "22%", height: "4%" }}>
                    <label className="block" htmlFor="email">
                      Email ID<span className="text-red-700 text-xl">*</span>
                    </label>
                    <input
                      className={`border w-full border-gray-400 rounded-md p-2 overflow-hidden shadow-md outline-none ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                      type="text"
                      placeholder="Enter Email ID"
                      disabled={isViewOnly}
                      value={ClientEmail}
                      onChange={(e) => setClientEmail(e.target.value)}
                    />
                  </div>

                  <div className="mb-4" style={{ width: "22%", height: "4%" }}>
                    <label className="block" htmlFor="Name">
                      Mobile Number
                      <span className="text-red-700 text-xl">*</span>
                    </label>
                    <PhoneInput
                      country={defaultCountry}
                      disableDropdown={true}
                      disableCountryGuess={true}
                      countryCodeEditable={false}
                      disabled={isViewOnly}
                      value={formatPhoneNumberForDisplay(ClientPhone)}
                      onChange={(value, country) => {
                        setClientPhone(value);
                      }}
                      onlyCountries={allowedCountries}
                      preferredCountries={[]}
                      enableSearch={true}
                      inputProps={{
                        required: true,
                        className: `w-full h-10 border text-sm border-gray-400 outline-0 rounded overflow-hidden shadow-md p-2 pl-10 ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`,
                        style: {
                          fontFamily:
                            "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif",
                        },
                      }}
                    />
                  </div>

                  <div className="mb-4" style={{ width: "22%", height: "4%" }}>
                    <label className="block" htmlFor="Source">
                      Lead Type<span className="text-red-700 text-xl">*</span>
                    </label>
                    <div className=" bg-white">
                      <div
                        ref={dropdownRefLeadType}
                        className="relative flex  p-0  rounded-xl align-middle items-center"
                      >
                        <ExpandMoreIcon
                          color="white"
                          className={`absolute right-2 m-auto bg-white ${isViewOnly ? "cursor-not-allowed" : "cursor-pointer"}`}
                          onClick={() => {
                            if (isViewOnly) return;
                            setShowLeadTypeDropdown(!showLeadTypeDropdown);
                          }}
                        />

                        <button
                          type="button"
                          disabled={isViewOnly}
                          onClick={() => {
                            if (isViewOnly) return;
                            setShowLeadTypeDropdown(!showLeadTypeDropdown);
                          }}
                          className={`border w-full bg-white border-gray-400 text-nowrap rounded-md p-2 shadow-md text-start overflow-hidden outline-none ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                        >
                          {LeadType ? LeadType : <p>Select Lead Type</p>}
                        </button>

                        {showLeadTypeDropdown && (
                          <div
                            style={{ zIndex: 9999 }}
                            className="absolute top-full p-1 left-0 w-full cursor-pointer max-h-96 overflow-y-auto bg-white text-sm border border-gray-300 shadow-lg flex flex-col gap-1"
                          >
                            {LeadTypes.map((LeadTyp) => (
                              <div
                                className="p-1 hover:bg-gray-200 cursor-pointer"
                                onClick={() =>
                                  handleLeadTypeChange(LeadTyp.LeadType)
                                }
                                key={LeadTyp.id}
                                value={LeadTyp.LeadType}
                              >
                                {LeadTyp.LeadType}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="grid grid-cols-1 md:grid-cols-4 gap-4"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  {/* Status */}
                  <div className="pt-1" style={{ width: "22%", height: "4%" }}>
                    <label className="block" htmlFor="Status">
                      Status<span className="text-red-700 text-xl">*</span>
                    </label>
                    <div className=" bg-white">
                      <div
                        ref={dropdownRefStatus}
                        className="relative flex  p-0  rounded-xl align-middle items-center"
                      >
                        <ExpandMoreIcon
                          color="white"
                          className={`absolute right-2 m-auto bg-white 
                         ${isViewOnly || editingLeadReport?.Status === "Won" ||
                              editingLeadReport?.Status === "won"
                              ? "cursor-not-allowed opacity-50"
                              : "cursor-pointer"
                            }`}
                          onClick={() => {
                            if (isViewOnly) return;
                            if (
                              editingLeadReport?.Status === "Won" ||
                              editingLeadReport?.Status === "won"
                            )
                              return;
                            setShowStatusDropdown(!showStatusDropdown);
                          }}
                        />

                        <button
                          disabled={
                            isViewOnly ||
                            editingLeadReport?.Status === "Won" ||
                            editingLeadReport?.Status === "won"
                          }
                          type="button"
                          onClick={() => {
                            if (isViewOnly) return;
                            setShowStatusDropdown(!showStatusDropdown);
                          }}
                          className={`border w-full bg-white border-gray-400 text-nowrap rounded-md p-2 shadow-md text-start overflow-hidden outline-none ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                        >
                          {Status ? Status : <p>Select Status</p>}
                        </button>

                        {showStatusDropdown && (
                          <div
                            style={{ zIndex: 9999 }}
                            className="absolute top-full p-1 left-0 w-full cursor-pointer max-h-96 overflow-y-auto bg-white text-sm border border-gray-300 shadow-lg flex flex-col gap-1"
                          >
                            {statuses
                              .filter(
                                (s) =>
                                  editingLeadReport?.Status?.toLowerCase() ===
                                    "won recurring"
                                    ? s.status === "Won" // show only Won
                                    : true // otherwise show all
                              )
                              .map((statuse) => (
                                <div
                                  className="p-1 hover:bg-gray-200 cursor-pointer"
                                  onClick={() =>
                                    handleStatusChange(statuse.status)
                                  }
                                  key={statuse.id}
                                  value={statuse.status}
                                >
                                  {statuse.status}
                                </div>
                              ))}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* Probability */}
                  <div className="pt-1" style={{ width: "22%", height: "4%" }}>
                    <label className="block" htmlFor="Status">
                      Probability{" "}
                      {Status === "Pending" ? (
                        <span className="text-red-700 text-xl">*</span>
                      ) : (
                        <span className="text-red-700 text-xl"></span>
                      )}
                    </label>
                    <div className=" bg-white">
                      <div
                        ref={dropdownRefProbability}
                        className="relative flex  p-0  rounded-xl align-middle items-center"
                      >
                        <ExpandMoreIcon
                          color="white"
                          className={`absolute right-2 m-auto 
                          ${isViewOnly || Status !== "Pending"
                              ? "opacity-40 cursor-not-allowed"
                              : "cursor-pointer"
                            }`}
                          onClick={() => {
                            if (isViewOnly) return;
                            if (Status === "Pending") {
                              setShowProbabilityDropdown(
                                !showProbabilityDropdown
                              );
                            }
                          }}
                        />

                        <button
                          type="button"
                          onClick={() => {
                            if (isViewOnly) return;
                            setShowProbabilityDropdown(!showProbabilityDropdown);
                          }}
                          disabled={isViewOnly || Status !== "Pending"}
                          className={`border w-full border-gray-400 text-nowrap rounded-md p-2 shadow-md text-start overflow-hidden outline-none ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : Status !== "Pending" ? "bg-gray-200" : ""}`}
                        >
                          {Probability ? (
                            Probability
                          ) : (
                            <p>Select Probability</p>
                          )}
                        </button>

                        {showProbabilityDropdown && (
                          <div
                            style={{ zIndex: 9999 }}
                            className="absolute top-full left-0 w-full p-1 cursor-pointer max-h-96 overflow-y-auto bg-white text-sm border border-gray-300 shadow-lg flex flex-col gap-1"
                          >
                            <div
                              className="p-1 hover:bg-gray-200 cursor-pointer"
                              onClick={() => handleProbabilityChange("High")}
                            >
                              High
                            </div>
                            <div
                              className="p-1 hover:bg-gray-200 cursor-pointer"
                              onClick={() => handleProbabilityChange("Medium")}
                            >
                              Medium
                            </div>
                            <div
                              className="p-1 hover:bg-gray-200 cursor-pointer"
                              onClick={() => handleProbabilityChange("Low")}
                            >
                              Low
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div
                    className="pt-1"
                    style={{ width: "22.5%", height: "4%" }}
                  >
                    <label className="block " htmlFor="date">
                      {Status === "Won" || Status === "Lost" ? (
                        ""
                      ) : (
                        <>
                          {" "}
                          Next Follow-up Date
                          <span className="text-red-700 text-xl">*</span>
                        </>
                      )}
                    </label>
                    {Status !== "Won" && Status !== "Lost" && (
                      // <DatePicker
                      //   selected={FollowupDate}
                      //   onChange={(date) => setFollowupDate(date)}
                      //   dateFormat={getDateFormat()}
                      //   placeholderText={getDatePlaceholder()}
                      //   minDate={
                      //     LeadDate
                      //       ? new Date(
                      //         new Date(LeadDate).setDate(
                      //           new Date(LeadDate).getDate() + 1
                      //         )
                      //       )
                      //       : null
                      //   }
                      //   customInput={
                      //     <InputMask
                      //       mask="99-99-9999"
                      //       placeholder={getDatePlaceholder()}
                      //       className="border w-full pr-16 border-gray-400 rounded-md p-2 overflow-hidden shadow-md outline-none"
                      //     />
                      //   }
                      //   onChangeRaw={(e) => {
                      //     const inputValue = e.target.value;
                      //     if (!inputValue || inputValue.length < 10) return;

                      //     const [month, day, year] = inputValue.split("-");
                      //     const parsedDate = new Date(`${year}-${month}-${day}`);
                      //     if (parsedDate instanceof Date && !isNaN(parsedDate)) {
                      //       setFollowupDate(parsedDate);
                      //     }
                      //   }}
                      // />

                      <DatePicker
                        selected={FollowupDate}
                        dateFormat={getDateFormat()}
                        placeholderText={getDatePlaceholder()}
                        minDate={LeadDate}
                        showPopperArrow={false}
                        disabled={isViewOnly}
                        onChange={(date) => {
                          if (!(date instanceof Date) || isNaN(date)) return;

                          if (LeadDate && date < LeadDate) {
                            enqueueSnackbar(
                              "Follow-up date must be after Lead Date",
                              { variant: "error" }
                            );
                            return;
                          }

                          setFollowupDate(date);
                        }}
                        onBlur={(e) => {
                          const parsed = parseTypedDate(
                            e.target.value,
                            getDateFormat
                          );
                          if (!parsed) return;

                          if (LeadDate && parsed < LeadDate) {
                            enqueueSnackbar(
                              "Follow-up date must be after Lead Date",
                              { variant: "error" }
                            );
                            return;
                          }
                          setFollowupDate(parsed);
                        }}
                        className={`border w-full pr-16 border-gray-400 rounded-md p-2 shadow-md outline-none ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                      />
                    )}
                  </div>

                  <div
                    className="pt-1 flex gap-2"
                    style={{ width: "22%", height: "4%" }}
                  >
                    <FileUploadEditLead
                      seteditFetchedFiles={seteditFetchedFiles}
                      editfetchedfiles={editfetchedfiles}
                      SelectedCategory={SelectedCategory}
                      setSelectedCategory={setSelectedCategory}
                      setFileNames={setFileNames}
                      editingLeadReport={editingLeadReport}
                    />
                  </div>
                </div>
                <br></br>

                {/* Comments */}
                <div className="w-full flex">
                  <div className="w-1/2 pr-5">
                    <label className="block" htmlFor="comments">
                      Comments
                    </label>
                    <textarea
                      className={`border w-full border-gray-400 rounded-md p-4 overflow-hidden shadow-md outline-none resize-none ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                      placeholder="Enter Comments"
                      id="comments"
                      value={comments}
                      disabled={isViewOnly}
                      onChange={(e) => setComments(e.target.value)}
                      required={Status === "Pending"}
                      name="comments"
                      rows={2}
                    />
                  </div>
                </div>

                <div className="flex mt-8 gap-5 justify-start">
                  <button
                    onClick={Submit}
                    disabled={isViewOnly}
                    className={`py-2 px-7 overflow-hidden shadow-md rounded-lg ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : "bg-[#e32278] text-white"}`}
                  >
                    Confirm
                  </button>
                  <button
                    onClick={() => {
                      Cancel();
                      dispatch(resetcurrentLeadID());
                    }}
                    className="py-2 px-7 bg-black hover:bg-white hover:text-black border border-black overflow-hidden shadow-md text-white rounded-lg"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>

            <br />
          </div>
        </>
      )}
    </div>
  );
};

export default EditLead;
